import styled from '@emotion/styled'
import { tokens } from '@news-mono/design-tokens'
import { calcRem } from '../../../__styling/style-functions/calc-rem'
import { IconCross } from '../../../navigation/TNFlyoutNav/assets/IconCross'
import { breakpointMax, metrics } from '../../../__styling'
import { keyframes } from '@emotion/css'
import { zIndex } from '../../../__styling/settings/z-index'

const palette = tokens.thenightly.colors.palette

export interface StickyAccountBannerProps {
    isHidden: boolean
}

const gap = calcRem(metrics.thenightly.margins.md)

export const StyledContainer = styled('div')<StickyAccountBannerProps>(
    (props) => ({
        background: tokens.thenightly.colors.palette.neutral[100],
        paddingLeft: metrics.thenightly.margins.m2l,
        paddingRight: metrics.thenightly.margins.m2l,
        paddingTop: metrics.thenightly.margins.md,
        paddingBottom: metrics.thenightly.margins.md,
        display: 'block',
        alignItems: 'center',
        gap: gap,
        position: 'sticky',
        zIndex: zIndex.thenightly.stickyCreateAccountBanner,
        top: `var(--stickyHeaderHeight)`,

        transition: 'top 0.25s',

        animationTimingFunction: 'ease',
        animationFillMode: 'forwards',

        '&': [
            // stick to the top of the page directly, no animation needed
            !props.isHidden && {
                animationDuration: '250ms',
                animationName: keyframes({
                    '0%': { opacity: 0 },
                    '100%': {
                        opacity: 1,
                    },
                }),
            },
        ],
    }),
)

export const StyledRowContainer = styled('div')({
    margin: '0 auto',
    position: 'relative',
    maxWidth: metrics.thenightly.siteMetrics.mainContentWidth,
    display: 'flex',
    alignItems: 'center',
})

export const StyledInnerRowContainer = styled('div')({
    position: 'relative',
    display: 'flex',
    alignItems: 'flex-start',
    [breakpointMax('sm')]: {
        flexDirection: 'column',
    },
})

export const StyledCloseButtonContainer = styled('button')({
    flexShrink: 0,
    display: 'flex',
    outline: 'none',
    background: 'none',
    border: 'none',
    margin: 0,
    padding: 0,
    textUnderlinePosition: 'under',
})

export const StyledIconCross = styled(IconCross)({
    height: calcRem(24),
    width: calcRem(24),
    fill: tokens.thenightly.colors.palette.neutral[30],
    '&:hover': {
        cursor: 'pointer',
    },
    marginRight: metrics.thenightly.margins.md,
})

export const StyledTextContainer = styled('p')({
    fontSize: calcRem(16),
    lineHeight: 1.5,
    fontStyle: 'normal',
    fontWeight: 600,
    color: palette.neutral[0],
    margin: 0,
})

/** The styles for a text link */
export const StyledTextLink = styled('a')({
    textDecoration: 'underline',
    color: palette.starlight.default,
    fontSize: metrics.thenightly.baseFontSize,
    lineHeight: 1.5,
    fontStyle: 'normal',
    fontWeight: 400,
    paddingLeft: calcRem(16),
    '&:hover': {
        cursor: 'pointer',
    },
    [breakpointMax('sm')]: {
        paddingLeft: 0,
    },
})
